import { render, staticRenderFns } from "./GearRatioInsights.vue?vue&type=template&id=6904a4ce&scoped=true&"
import script from "./GearRatioInsights.vue?vue&type=script&lang=js&"
export * from "./GearRatioInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6904a4ce",
  null
  
)

export default component.exports